import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Calendar, GraduationCap, ArrowRight, Sparkles, Download } from 'lucide-react';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
import { Formation } from '../data/constants';
interface FormationCardProps {
  formation: Formation;
}
export function FormationCard({
  formation
}: FormationCardProps) {
  return <Card className={`flex flex-col h-full border-none hover:-translate-y-2 transition-all duration-500 overflow-hidden group bg-white ${formation.isNew ? 'shadow-2xl ring-2 ring-brand-orange hover:shadow-2xl' : 'shadow-lg hover:shadow-xl'}`} data-id="element-345" data-mp="2qx6nsat8ihdi">
      <div className={`h-2 w-full transition-colors duration-500 ${formation.isNew ? 'bg-brand-orange' : 'bg-primary group-hover:bg-brand-orange'}`} data-id="element-346" data-mp="10l0r0wnfwbs9" />
      <CardHeader className="pt-8" data-id="element-347" data-mp="2qsu8jzlulfqh">
        <div className="flex flex-wrap gap-2 mb-4" data-id="element-348" data-mp="2qtvw33k1vup3">
          {formation.isNew && <Badge variant="default" className="bg-brand-orange text-white hover:bg-brand-orange border-none font-bold uppercase tracking-wider flex items-center gap-1.5" data-id="element-349" data-mp="2m245it0w9oyy">
              <Sparkles className="w-3.5 h-3.5" data-id="element-350" data-mp="2d2z3hcq4jdi1" />
              Nouveauté
            </Badge>}
          <Badge variant="default" className="bg-lavande text-primary-dark hover:bg-lavande/80 border-none font-bold" data-id="element-351" data-mp="39qn8ct16d9jn">
            {formation.level}
          </Badge>
          <Badge variant="outline" className="text-muted-foreground border-slate-200" data-id="element-352" data-mp="30pp3y9mtr00j">
            {formation.rncp}
          </Badge>
        </div>
        <CardTitle className="text-2xl md:text-3xl leading-tight font-heading font-extrabold text-primary-dark group-hover:text-primary transition-colors" data-id="element-353" data-mp="1pd4rexdmpsyu">
          {formation.title}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1 space-y-6" data-id="element-354" data-mp="1lupamatifx90">
        <p className="text-muted-foreground text-lg leading-relaxed line-clamp-3" data-id="element-355" data-mp="1qt0kumnpw9rr">
          {formation.description}
        </p>
        <div className="space-y-3 pt-6 border-t border-slate-100 text-base text-muted-foreground" data-id="element-356" data-mp="1csg19o9za9x7">
          <div className="flex items-center gap-3 group/item" data-id="element-357" data-mp="1hr9ctb5pfquq">
            <Clock className="w-5 h-5 text-brand-orange group-hover/item:animate-soft-bounce" data-id="element-358" data-mp="133y0h71p82tk" />
            <span className="font-medium" data-id="element-359" data-mp="17u4op5satlba">Durée : {formation.duration}</span>
          </div>
          <div className="flex items-center gap-3 group/item" data-id="element-360" data-mp="u2zy0t6ws3d3">
            <Calendar className="w-5 h-5 text-brand-orange group-hover/item:animate-soft-bounce" data-id="element-361" data-mp="u4uik6e9ptgn" />
            <span className="font-medium" data-id="element-362" data-mp="y4uvtnpmrym4">Rythme : {formation.rhythm}</span>
          </div>
          <div className="flex items-center gap-3 group/item" data-id="element-363" data-mp="k5c1bxpqslsa">
            <GraduationCap className="w-5 h-5 text-brand-orange group-hover/item:animate-soft-bounce" data-id="element-364" data-mp="p4g7efhde3ee" />
            <span className="font-medium" data-id="element-365" data-mp="5hbnx38bzkh2">Rentrée : {formation.rentree}</span>
          </div>
        </div>
        {formation.catalogueUrl && <a href={formation.catalogueUrl} download className="flex items-center gap-3 bg-lavande hover:bg-lavande/70 rounded-2xl px-5 py-4 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange" data-id="element-366" data-mp="kv2whwfhm87">
            <span className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shrink-0" data-id="element-367" data-mp="ofo77hsyiaqd">
              <Download className="w-5 h-5 text-brand-orange" data-id="element-368" data-mp="jhcyjaeee69q" />
            </span>
            <span className="font-bold text-primary-dark leading-tight" data-id="element-369" data-mp="y5r0lj3zpqp8">
              Télécharger le programme
              <span className="block text-sm font-medium text-primary-dark/60" data-id="element-370" data-mp="t87nimj13jyv">
                Fiche formation au format PDF
              </span>
            </span>
          </a>}
      </CardContent>
      <CardFooter className="flex flex-col sm:flex-row gap-4 pt-8 pb-8" data-id="element-371" data-mp="137gagvfh7ybq">
        <Button variant="outline" className="w-full text-primary-dark border-primary/20 hover:bg-primary/5 font-semibold" asChild data-id="element-372" data-mp="2wnkri3edwq2p">
          <Link to={`/formations/${formation.id}`} data-id="element-373" data-mp="36ens743ej31g">Voir le programme</Link>
        </Button>
        <Button className="w-full group/btn bg-brand-orange hover:bg-[#E67E22] text-white font-semibold" asChild data-id="element-374" data-mp="3bdih8nrypnu0">
          <Link to="/candidater" data-id="element-375" data-mp="2dr1nttmcnudj">
            Candidater
            <ArrowRight className="w-5 h-5 ml-2 group-hover/btn:translate-x-1 transition-transform" data-id="element-376" data-mp="2iol22tj1s75h" />
          </Link>
        </Button>
      </CardFooter>
    </Card>;
}